import { useEffect, useState } from "react";
import { LogIn, Plus, Pencil, Trash2, CheckCircle, Upload, MessageSquare, Activity } from "lucide-react";
import api from "@/lib/api";
import { AdminHeader } from "@/components/admin/AdminShared";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";

const ICONS = { Login: LogIn, Create: Plus, Update: Pencil, Delete: Trash2, Approve: CheckCircle, Publish: Upload };

export default function AuditLogAdmin() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/audit-logs").then((r) => setItems(r.data)); }, []);

  return (
    <div>
      <AdminHeader title="Audit Log" description="Catatan aktivitas admin dalam sistem." />
      <div className="bg-white border border-slate-200 rounded-xl overflow-x-auto" data-testid="audit-table">
        <Table>
          <TableHeader>
            <TableRow className="bg-surface"><TableHead>User</TableHead><TableHead>Aktivitas</TableHead><TableHead>Objek</TableHead><TableHead>Detail</TableHead><TableHead>Tanggal &amp; Waktu</TableHead><TableHead>IP</TableHead></TableRow>
          </TableHeader>
          <TableBody>
            {items.map((l) => {
              const Icon = ICONS[l.activity] || Activity;
              return (
                <TableRow key={l.id}>
                  <TableCell className="font-mono text-sm font-semibold text-navy">{l.username}</TableCell>
                  <TableCell><span className="inline-flex items-center gap-1.5 text-sm text-slate-600"><Icon className="h-4 w-4 text-brandred" /> {l.activity}</span></TableCell>
                  <TableCell className="text-sm text-slate-500">{l.object}</TableCell>
                  <TableCell className="text-sm text-slate-500 max-w-xs"><span className="line-clamp-1">{l.detail}</span></TableCell>
                  <TableCell className="text-sm text-slate-500">{new Date(l.created_at).toLocaleString("id-ID")}</TableCell>
                  <TableCell className="text-xs font-mono text-slate-400">{l.ip}</TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
